import React from 'react';
import { cx } from '@linaria/core';
import { textRegular } from 'styles/typography';
import { withAuth } from 'hocs/withAuth/withAuth';
import { pageTitle, subtitle } from 'modules/PageNotFound/PageNotFound.styles';
import { Button } from 'components/ui_library/Button';
import { flex } from 'styles/utils';
import { IconRing } from 'components/IconRing';
import { NavLink } from 'components/Navbar/components';
import { useRouter } from 'next/router';
import { sidebarWrapper, errorUIContainer, errorTitle, buttonGroup, center } from './Sidebar.styles';

interface PredictionSidebarErrorUIProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
}

export const PredictionSidebarErrorUI: React.FC<PredictionSidebarErrorUIProps> = ({ title, description, className, ...props }) => (
  <div className={cx(errorUIContainer, className)} {...props}>
    <h1 className={pageTitle}>{title}</h1>
    <h2 className={cx(textRegular, subtitle)}>{description}</h2>
    <img src="/character-robot.svg" alt="" />
  </div>
);

interface ErrorUIProps extends PredictionSidebarErrorUIProps {
  isLoggedIn?: boolean;
}
export const FetchingErrorUI: React.FC<ErrorUIProps> = withAuth<ErrorUIProps>()(({ isLoggedIn, title, description }: ErrorUIProps) => {
  const defaultTitle = 'Oops!';
  const defaultDescription = 'Something went wrong with fetching the model predictions. Please reload or try again later.';
  return (
    <div className={sidebarWrapper}>
      {isLoggedIn && (
        <PredictionSidebarErrorUI data-testid="fetchingErrorUI" title={title || defaultTitle} description={description || defaultDescription} />
      )}
    </div>
  );
});

export const RetryErrorUI: React.FC = () => <PredictionSidebarErrorUI data-testid="retryErrorUI" title="Oops!" description="RETRYING..." />;

export const LoginOrSignUpErrorUI: React.FC = () => {
  const { asPath } = useRouter();

  return (
    <div data-testid="loginOrSignupErrorUI" className={cx(sidebarWrapper, flex.alignItems.center, flex.gap[1])}>
      <div>
        <IconRing>
          <div className={center}>
            <img src="/clarifai-logo-transparent-bg.svg" alt="Clarifai" />
          </div>
        </IconRing>
      </div>
      <h1 className={errorTitle}>Sign up or Log in to view model predictions.</h1>
      <div className={buttonGroup}>
        <NavLink href="/login" className={flex.flex.one} currentPath={asPath}>
          <Button variant="tertiary" size="md">
            Log in
          </Button>
        </NavLink>
        <NavLink href="/signup" className={flex.flex.one} currentPath={asPath}>
          <Button size="md">Sign up</Button>
        </NavLink>
      </div>
    </div>
  );
};
